var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmiratesId(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "request_quote"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11 19.3906H13V18.3906H14C14.2833 18.3906 14.5208 18.2948 14.7125 18.1031C14.9042 17.9115 15 17.674 15 17.3906V14.3906C15 14.1073 14.9042 13.8698 14.7125 13.6781C14.5208 13.4865 14.2833 13.3906 14 13.3906H11V12.3906H15V10.3906H13V9.39063H11V10.3906H10C9.71667 10.3906 9.47917 10.4865 9.2875 10.6781C9.09583 10.8698 9 11.1073 9 11.3906V14.3906C9 14.674 9.09583 14.9115 9.2875 15.1031C9.47917 15.2948 9.71667 15.3906 10 15.3906H13V16.3906H9V18.3906H11V19.3906ZM6 22.3906C5.45 22.3906 4.97917 22.1948 4.5875 21.8031C4.19583 21.4115 4 20.9406 4 20.3906V4.39063C4 3.84063 4.19583 3.36979 4.5875 2.97813C4.97917 2.58646 5.45 2.39062 6 2.39062H14L20 8.39063V20.3906C20 20.9406 19.8042 21.4115 19.4125 21.8031C19.0208 22.1948 18.55 22.3906 18 22.3906H6ZM13 8.39063V4.39063H6V20.3906H18V8.39063H13Z",
    fill: "#EB151C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmiratesId);
export default __webpack_public_path__ + "static/media/emirates-id.7e109a15108f9d86e506d37ed14c37aa.svg";
export { ForwardRef as ReactComponent };